import { Dialog } from "../../../../../../shared/lib/html5-software-library/src/ranj/eng/dialog/engine/model/Dialog";
import DefaultDialogPlayer from "../../../../../../shared/lib/html5-software-library/src/ranj/eng/dialog/framework/player/DefaultDialogPlayer";
import DialogMemento from "./DialogMemento";

export default class ResumableDefaultDialogPlayer extends DefaultDialogPlayer {
    
    constructor(timeTickInterval = 100) {
        super(timeTickInterval);
    }

    getCurrentCommandSequence() {
        return this.dialogPlayer.getCurrentCommandSequence();
    }

    /**
     * @param {DialogMemento} dialogMemento 
     */
    loadMemento(dialogMemento) {
        const { commandSequenceId } = dialogMemento;
        this.jumpToCommandSequence(commandSequenceId);
    }

    /**
     * @param {String} commandSequenceId 
     */
    jumpToCommandSequence(commandSequenceId) {
        /**@type {Dialog} */
        const dialog = this.dialogPlayer.getDialog();
        const state = dialog.states.find(state => state.id == commandSequenceId);
        this.reset();
        this.dialogPlayer.enterCommandSequence(state);
    }
}
